export const RUI_TOAST_SHOW_EVENT = "rui-toast-show";
export const RUI_TOAST_DISMISS_EVENT = "rui-toast-dismiss";
export const TOAST_POSITIONS = ["top-start", "top-center", "top-end", "bottom-start", "bottom-center", "bottom-end"];
export const TOAST_LIFETIME = 4e3;
export const TOAST_WIDTH = 356;
export const TOAST_GAP = 14;
export const TOAST_VIEWPORT_OFFSET = 24;
export const TOAST_VISIBLE_AMOUNT = 3;
export const TOAST_COLLAPSED_PEEK = 3;
export const TOAST_SWIPE_THRESHOLD = 45;
export const TOAST_EXIT_MS = 200;
export const DEFAULT_TOAST_POSITION = "bottom-end";
export function splitToastPosition(position) {
  const [y, x] = position.split("-");
  return {
    y,
    x
  };
}